var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ViewType } from "../../models/view-type";
import { Base } from "../base";
import { Icon } from "./icon";
var Header = /** @class */ (function (_super) {
    __extends(Header, _super);
    function Header(configuration, viewType, maximizeWindowAction, minimizeWindowAction, closeWindowAction) {
        var _this = _super.call(this) || this;
        _this.maximizeWindow = function () {
            _this._maximizeWindowIcon.hide();
            _this._minimizeWindowIcon.show();
            _this._maximizeWindowAction();
            _this._minimizeWindowIcon.focus();
        };
        _this.minimizeWindow = function () {
            _this._minimizeWindowIcon.hide();
            _this._maximizeWindowIcon.show();
            _this._minimizeWindowAction();
            _this._maximizeWindowIcon.focus();
        };
        _this.closeWindow = function () {
            _this._closeWindowAction();
        };
        _this._minimizeWindowAction = minimizeWindowAction;
        _this._maximizeWindowAction = maximizeWindowAction;
        _this._closeWindowAction = closeWindowAction;
        _this._backgroundColor = configuration.backgroundColor;
        _this._fontColor = configuration.headerFontColor;
        _this._text = configuration.headerText;
        _this._iconsColor = configuration.headerIconsColor;
        var header = document.createElement('div');
        header.id = 'js_aigo_bot_header';
        header.innerText = _this._text;
        header.style.background = _this._backgroundColor;
        header.style.color = _this._fontColor;
        header.style.height = '34px';
        header.style.alignContent = 'center';
        header.style.paddingInline = '10px';
        var controls = document.createElement('div');
        controls.style.float = 'right';
        controls.style.display = 'inline-flex';
        _this._closeWindowIcon = new Icon('js_aigo_bot_close_window_icon', "data:image/svg+xml;base64, ".concat(process.env.AIGO_CHAT_HEADER_CLOSE_WINDOW_ICON_IN_BASE64), '9px', '9px', _this._iconsColor, null, _this.closeWindow, true, 'Close window');
        // the maximize and the minimize icons should be presented only for desktop
        if (viewType === ViewType.DesktopLarge || viewType === ViewType.DesktopSmall) {
            header.style.borderTopLeftRadius = '5px';
            header.style.borderTopRightRadius = '5px';
            header.style.marginBottom = '-5px';
            var maximizeWindowIcon = new Icon('js_aigo_bot_maximize_window_icon', "data:image/svg+xml;base64, ".concat(process.env.AIGO_CHAT_HEADER_MAXIMIZE_WINDOW_ICON_IN_BASE64), '14px', '10px', _this._iconsColor, null, _this.maximizeWindow, true, 'Maximize window');
            var minimizeWindowIcon = new Icon('js_aigo_bot_minimize_window_icon', "data:image/svg+xml;base64, ".concat(process.env.AIGO_CHAT_HEADER_MINIMIZE_WINDOW_ICON_IN_BASE64), '12px', '2px', _this._iconsColor, '12px', _this.minimizeWindow, true, 'Minimize window');
            minimizeWindowIcon.hide();
            _this._minimizeWindowIcon = minimizeWindowIcon;
            _this._maximizeWindowIcon = maximizeWindowIcon;
            controls.appendChild(maximizeWindowIcon.self);
            controls.appendChild(minimizeWindowIcon.self);
        }
        else {
            header.style.borderTopLeftRadius = '';
            header.style.borderTopRightRadius = '';
            header.style.marginBottom = '';
            header.style.position = 'sticky';
            header.style.top = '0px';
            header.style.zIndex = '1';
        }
        controls.appendChild(_this._closeWindowIcon.self);
        header.appendChild(controls);
        _this.self = header;
        return _this;
    }
    Header.prototype.focus = function () {
        if (this._maximizeWindowIcon && this._maximizeWindowIcon.self.style.display !== 'none') {
            this._maximizeWindowIcon.focus();
            return;
        }
        if (this._minimizeWindowIcon && this._minimizeWindowIcon.self.style.display !== 'none') {
            this._minimizeWindowIcon.focus();
            return;
        }
        this._closeWindowIcon.focus();
    };
    return Header;
}(Base));
export { Header };
